let getImg = url => {
  return require("@/assets/img/" + url)
}

export { getImg }
